import { useCallback, useMemo } from 'react';

import { useOfficeEditingCtx } from '@/app/(app)/settings/office/provider';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function OfficeLocation() {
  const { office, update } = useOfficeEditingCtx();
  const location = useMemo(() => {
    if (!office.location) {
      return {
        office_id: office.id,
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        latitude: null,
        longitude: null,
      };
    }
    return office.location;
  }, [office.location, office.id]);

  const onChange = useCallback(
    (updates: Partial<typeof location>) => {
      update({
        location: {
          ...location,
          ...updates,
        },
      });
    },
    [location, update]
  );

  return (
    <div className='flex w-full flex-col gap-4'>
      <h2 className='text-heading-md'>Office Location</h2>
      <div className='grid grid-cols-2 gap-x-2 gap-y-3'>
        <div className='space-y-2'>
          <Label htmlFor='line1'>Line 1</Label>
          <Input id='line1' value={location.line1} onChange={(e) => onChange({ line1: e.target.value })} />
        </div>
        <div className='space-y-2'>
          <Label htmlFor='line2'>Line 2</Label>
          <Input id='line2' value={location.line2 ?? ''} onChange={(e) => onChange({ line2: e.target.value })} />
        </div>
        <div className='space-y-2'>
          <Label htmlFor='city'>City</Label>
          <Input id='city' value={location.city} onChange={(e) => onChange({ city: e.target.value })} />
        </div>
        <div className='grid grid-cols-2 gap-x-2'>
          <div className='space-y-2'>
            <Label htmlFor='state'>State</Label>
            <Input id='state' value={location.state} onChange={(e) => onChange({ state: e.target.value })} />
          </div>
          <div className='space-y-2'>
            <Label htmlFor='zip'>Zip</Label>
            <Input id='zip' value={location.zip} onChange={(e) => onChange({ zip: e.target.value })} />
          </div>
        </div>
      </div>
      <div className='mt-4 grid grid-cols-2 gap-x-2 gap-y-3'>
        <div className='space-y-2'>
          <Label htmlFor='latitude'>Latitude</Label>
          <Input
            id='latitude'
            value={location.latitude ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              if (!value || isNaN(Number(value))) {
                return;
              }
              onChange({ latitude: Number(value) });
            }}
          />
        </div>
        <div className='space-y-2'>
          <Label htmlFor='longitude'>Longitude</Label>
          <Input
            id='longitude'
            value={location.longitude ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              if (!value || isNaN(Number(value))) {
                return;
              }
              onChange({ longitude: Number(value) });
            }}
          />
        </div>
      </div>
    </div>
  );
}
